// TODO: move to `enums.ts`
export enum VFTValidationType {
    Standard = 1,
    Configurable = 2,
    RequiredField = 3,
    BuyerCustom = 4,
    BuyerCustomNonValidation = 5,
    SourceDocumentIssue = 6,
}
